import React, {useState} from "react";
import {Accordion, Nav} from "react-bootstrap";

import { CaretDownFill, CaretUpFill } from "react-bootstrap-icons";
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import {NavLink} from "react-router-dom";

function CustomToggle({ eventKey, setCollapsed, collapsed, title, icon }) {
    const decoratedOnClick = useAccordionButton(eventKey, () =>
        setCollapsed( !collapsed )
    );

    const caret = collapsed ? <CaretDownFill/> : <CaretUpFill /> ;

    const IconClass = icon;

    return (
        <Nav.Item className='estar-menu-group'>
            <Nav.Link href="#" onClick={decoratedOnClick}>
                <IconClass />
                <div style={{display: 'inline'}}>{title}</div>
                <div style={{display: 'inline', float: 'right'}}>{caret}</div>
            </Nav.Link>
        </Nav.Item>

    );
}

const SubMenu = ({icon, title, items }) => {

    const [collapsed, setCollapsed] = useState(true);

    const cname = collapsed ? '' : 'open';

    // Still needs som eowkr - taken from here https://stackblitz.com/edit/react-sidebar-example-application?file=components%2Fsidebar%2FSubMenu.js

    return (
        <Nav.Item className={cname} key='tn'>
            <Accordion defaultActiveKey="" style={{backgroundColor: '#f5f9fd'}} >
                <CustomToggle eventKey="0" setCollapsed={setCollapsed} collapsed={collapsed} title={title} icon={icon}/>
                <Accordion.Collapse eventKey="0">
                    <nav className="nav flex-column">
                        {items.map((item) =>
                        {
                            const cname = "nav-link nav-item" + (item === "Active" ? "active" : "");

                            const IconClass = item.icon;

                            const urlPlusMenu = item.url + '?activeMenu=' + item.keyName ;

                            return <NavLink className={cname} to={urlPlusMenu} key={item.keyName}>
                                <IconClass/>
                                <div className='sidebar-display-text' key={'b' + item.keyName }>{item.text}</div>
                            </NavLink>

                        })}
                    </nav>
                </Accordion.Collapse>
            </Accordion>
        </Nav.Item>
    );

}

export default SubMenu;
